import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import goals from './Goal/ducks'
import { ducks as documents } from './Documents'
import { ducks as observations } from '@medeo/observations'
import { ducks as patients } from '@medeo/patients'
import { ducks as user } from '@medeo/user'
import { ducks as careplans } from './Careplan'
import { ducks as careteams } from './Careteam'
import group from './Group/ducks'

export default combineReducers({
  router: routerReducer,
  user,
  observations,
  goals,
  patients,
  documents,
  careplans,
  careteams,
  group
})



// WEBPACK FOOTER //
// ./src/reducers.js